import { ACCOUNT_DELETION } from "../../resources/actionTypes";

const initialState = {
  userDetails: {},
  loading: false,
  error: null,
};

export const accountDeletion = (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNT_DELETION.ACCOUNT_DELETION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case ACCOUNT_DELETION.ACCOUNT_DELETION_SUCCESS:
      return {
        ...state,
        loading: false,
        userDetails: action.userDetails,
      };
    case ACCOUNT_DELETION.ACCOUNT_DELETION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
   
    default:
      return state;
  }
};

